import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input, Button } from 'antd';

class Filter extends Component {
    static contextTypes = {
        roleAuth: PropTypes.bool,
        isCompleted: PropTypes.bool,
    }

    handleChange = (value, key) => {
        const { searchParams, onChange } = this.props;
        searchParams[key] = value;
        onChange(searchParams);
    }

    render() {
        const { batch, update, search, searchParams, loading } = this.props;
        const { roleAuth, isCompleted  } = this.context;
        return (
            <div style={{marginBottom: 16}}>
                <div className="search-bar">
                    <div className="search-item">
                        <label className='ui-label'>中心编号</label>
                        <Input
                            placeholder="请输入"
                            value={searchParams.siteCode}
                            onChange={e => this.handleChange(e.target.value, 'siteCode')}
                        />
                    </div>
                    <div className='search-item'>
                        <label className='ui-label'>中心名称</label>
                        <Input
                            placeholder="请输入"
                            value={searchParams.siteName}
                            onChange={e => this.handleChange(e.target.value, 'siteName')}
                        />
                    </div>
                    <div className='search-item'>
                        <Button type="primary" onClick={search}>搜索</Button>
                        {
                            !isCompleted && roleAuth &&
                            <Button type="primary" onClick={() => update({}, 'add')}>添加</Button>
                        }
                        {
                            !isCompleted && roleAuth &&
                            <Button className="btn-green" disabled={loading} onClick={batch}>中心-合同批量关联</Button>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/site/researchCenterDetail/components/Filter.js